/* tslint:disable */
/* eslint-disable */
export enum BusinessTypeEnum {
  Company = 'Company',
  Trust = 'Trust',
  Other = 'Other'
}
